export default "__VITE_ASSET__D1Qj59wf__"